import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PageWrapper from "../../shared/wizard/PageWrapper";
import InjuredInput from "../components/InjuredInput";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Styles from "../AnonForms.module.css";
import { textToBoolean } from "../../../utilities/dataUtilities";
import { yesNoUnsure } from "../../../constants/options";
import inputUtilities from "../../../utilities/forms/formInputUtilities";

function Injuries({
  fields,
  utilities,
  pedestrians,
  setPedestrians,
}) {
  const injuredObj = useSelector((state) => state.anonAutoForm.injuredObj);

  const { createToggleInput } = utilities;

  const showButton = (array) => array.length < 4;
  const [showPedButton, setShowPedButton] = useState(showButton(pedestrians));

  const addAnother = (e, personArray, personObj, set) => {
    e?.preventDefault(); // don't submit form
      
      const newArray = [...personArray];
      const newPerson = {...personObj};
      for (let fieldName in newPerson) {
        newPerson[fieldName] = {
          ...newPerson[fieldName],
          fieldName: `${newPerson[fieldName].fieldName}${personArray.length}`,
        };
      }
      newArray.push(newPerson);
      set(newArray);
  };

  const createPerson = (person, personArray, setPersonArray, desc, index) => {
    const setPerson = (item) => {
      const oldInfo = [...personArray];
      oldInfo[index] = item;
      setPersonArray(oldInfo);
    };
    const createPersonInput = inputUtilities(
      person,
      setPerson,
      Styles
    ).createNoLabelInput;
    return (
      <li key={index} className={`${Styles.fadeIn} ${Styles.injuredContainer} ${Styles.inputContainer}`}>
        <InjuredInput injured={person} injuredDesc={desc} createInput={createPersonInput} />
         <i
                    className={`fa fa-trash ${Styles.trash}`}
                    aria-label="remove"
                  >
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      onClick={() => {
                        const info = [...personArray];
                        info.splice(index, 1);
                        setPersonArray(info);
                      }
                      }
                    />
                  </i>
      </li>
    );
  };

  useEffect(() => {
    setShowPedButton(showButton(pedestrians));
  }, [pedestrians.length])

  useEffect(() => {
    if (textToBoolean(fields.pedestrianInjured.value)) {
      if (pedestrians?.length < 1) {
        addAnother(null, pedestrians, injuredObj, setPedestrians);
      } else {
        setPedestrians([]);
      }
    }
  }, [fields.pedestrianInjured.value])

  return (
    <PageWrapper legendInfo="Injuries: ">
      {createToggleInput(fields.pedestrianInjured, "100%", yesNoUnsure, true)}

      {
        textToBoolean(fields.pedestrianInjured.value) && (
        <>
        {pedestrians.map((pedestrian, i) => 
            createPerson(
              pedestrian,
              pedestrians,
              setPedestrians,
              "Pedestrian",
              i)
            )}
          {showPedButton && (
            <div className={Styles.addButtonDiv}>
              <button
                onClick={(e) => addAnother(e, pedestrians, injuredObj, setPedestrians)}
                type="button"
                className={Styles.addButton}
              >
                Add Pedestrian
              </button>
            </div>
          )}
        </>
      )}
    </PageWrapper>
  );
}

export default Injuries;
